export default "__VITE_ASSET__db485fd4__"